import { createContext, useCallback, useContext, useState } from "react";
import { LeadFormDialog } from "@/components/landing/LeadFormDialog";

const LeadModalContext = createContext({ open: () => {}, close: () => {} });

export const LeadModalProvider = ({ children, categories = [] }) => {
  const [state, setState] = useState({ open: false, context: null });

  const open = useCallback((context) => {
    setState({ open: true, context: context || null });
  }, []);

  const close = useCallback(() => {
    setState((s) => ({ ...s, open: false }));
  }, []);

  return (
    <LeadModalContext.Provider value={{ open, close }}>
      {children}
      <LeadFormDialog
        open={state.open}
        onOpenChange={(v) => setState((s) => ({ ...s, open: v }))}
        context={state.context}
        categories={categories}
      />
    </LeadModalContext.Provider>
  );
};

export const useLeadModal = () => useContext(LeadModalContext);
